export default "__VITE_ASSET__2a56f703__"